import styled from "styled-components";

export const _LandingHighlighProductPetitPrinceDecorationBaseContainer = styled("div")(() => {
  return {
    position: "relative",
    zIndex: 2,
    width: "100%",
    height: "100%",
  } as const;
});
